import { render, staticRenderFns } from "./CustomersWOItems.vue?vue&type=template&id=c72cf96c&scoped=true"
import script from "./CustomersWOItems.vue?vue&type=script&lang=js"
export * from "./CustomersWOItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c72cf96c",
  null
  
)

export default component.exports